<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: true,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
        };
    },    
    computed: {
        display_none_check: {
            get: function () {
                return this.selectedItem ? this.selectedItem[this.item.displayOn] == this.item.displayOnValue ? true : false : false
            },
            set: function (newValue) {
                return newValue
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                   
                    this.display_none_check = val.value == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    mounted() {
        this.item.display = false
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label :item="item" :model_length="validation.$model.length"/>
        <input
            v-model="value"
            :max="item.character_count == 0 ? 10000 : item.character_count"
            :maxlength="item.character_count == 0 ? 10000 : item.character_count"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitted && validation.$error, 'bg-soft-secondary': this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem.additionalProp1.global ? true : false }"
            :disabled="this.$route.params.categoryName == 'globalupdate' ? false 
            : selectedItem.additionalProp1.global ? true : false"              
            :placeholder="item.placeholder"
        />
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>